interface FormSectionProps {
  title: string;
  children: React.ReactNode;
}

export function FormSection({ title, children }: FormSectionProps) {
  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden mb-4">
      <div className="bg-gray-50 border-b border-gray-200 px-4 py-2">
        <p className="text-sm font-semibold text-gray-600">{title}</p>
      </div>
      <div className="bg-white divide-y divide-gray-100">
        {children}
      </div>
    </div>
  );
}
